export var AudioFormat;
(function (AudioFormat) {
    AudioFormat["STEREO"] = "STEREO";
    AudioFormat["DOLBY"] = "DOLBY";
})(AudioFormat || (AudioFormat = {}));
